export function addCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function removeCommas(value) {
    return value.replace(/[^\d]/g, '');
}

export function formatValue(input) {
    let value = removeCommas(input.toString());
    return addCommas(value);
}
